import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DataTable, H6, P, H4, RowWithFlexCols, Dropdown, FlexRow } from '@contently/toolkit';
import styled from '@emotion/styled';
import useFilter from './useFilter';
import { convertStoryTopicsToArr, createTagData } from './tableConfig';

const FilterBorder = styled(Dropdown)`
  border-radius: 3px;
  border: 1px solid #d4d4d4;
  box-shadow: none;
  margin-right: 18px;
  margin-left: 1rem;
  width: 18rem;
  height: 2.5rem;
`;

const VerticalCenteredRow = styled(FlexRow)`
  align-items: center;
`;

const MarginTop = styled.div`
  margin-top: 1rem;
`;

function TableWrapper({ tableInfo, header, tagFilter, tableColumns, id }) {
  const storyTopics = convertStoryTopicsToArr(tableInfo);
  const [tagFilterState, setTagFilterState] = useState(storyTopics[0]);
  const emptyTableInfo = tableInfo.length < 1;
  const onlyTagTableData = !emptyTableInfo && tagFilter;

  const createTableData = () => {
    const columnHeader = tableColumns[0].Header;
    const emptySubject = columnHeader === 'StoryTopic' ? 'No Tags' : `No ${columnHeader}`;
    if (emptyTableInfo) {
      tableInfo.push({
        subject: emptySubject,
        search_traffic: 0,
        traffic_value: '$0'
      });
    }
    return onlyTagTableData ? createTagData(tableInfo, tagFilterState) : tableInfo;
  };

  const dropdownActions = useFilter(
    tagFilterState,
    setTagFilterState,
    'contentValueTagFilter',
    storyTopics
  );

  const TriggerButton = () => (
    <FlexRow margin="xsmall">
      <P>{tagFilterState}</P>
    </FlexRow>
  );

  return (
    <div id={id}>
      <RowWithFlexCols>
        <div>
          <H4>{header}</H4>
        </div>
        {onlyTagTableData && (
          <div>
            <VerticalCenteredRow align="right">
              <H6>Tag Group</H6>
              <FilterBorder
                links={dropdownActions}
                Trigger={TriggerButton}
                triggerArrow
                id="tag-filter"
              />
            </VerticalCenteredRow>
          </div>
        )}
      </RowWithFlexCols>
      <MarginTop>
        <DataTable.Table
          data={createTableData()}
          columns={tableColumns}
          pageSize={4}
          showTotal={false}
        />
      </MarginTop>
    </div>
  );
}

export default TableWrapper;

TableWrapper.defaultProps = {
  tagFilter: false,
  id: null
};

TableWrapper.propTypes = {
  tableInfo: PropTypes.arrayOf(
    PropTypes.shape({
      subject: PropTypes.string,
      traffic_value: PropTypes.string,
      search_traffic: PropTypes.string
    })
  ).isRequired,
  header: PropTypes.string.isRequired,
  tagFilter: PropTypes.bool,
  id: PropTypes.string,
  tableColumns: PropTypes.arrayOf(
    PropTypes.shape({
      Header: PropTypes.string.isRequired,
      accessor: PropTypes.string.isRequired,
      disableSortBy: PropTypes.bool.isRequired
    })
  ).isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/table_wrapper.jsx